export const getPortalId = () => {
  const appDataElement = document.getElementById('app-data');
  if (appDataElement) {
    const parsedData = JSON.parse(appDataElement.innerHTML);
    if (parsedData && parsedData?._id) {
      return parsedData._id;
    }
  }
  return null;
}

export const getChatbotEnable = () => {
  const nextDataElement = document.getElementById('__NEXT_DATA__');
  if (nextDataElement) {
    const parsedData = JSON.parse(nextDataElement.innerHTML);
    const customFields = parsedData?.props?.initialState?.session?.user?.customFields;
    if (customFields && customFields.chatbotEnabled) {
      return customFields.chatbotEnabled;
    }
  }
  return null;
}
